// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3EJ6k","overflowing":"ReadFullNote_overflowing__3CINt"};